import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProductDetails from "./pages/ProductDetails";
import Certificates from "./components/Certificates"
import Banner from "./components/Banner";
import Extracts from "./pages/Extracts";
import OilDetails from "./pages/oilDescriptions";
import EssentialOils from "./pages/EssentialOils";
import DryLeaves from "./pages/DryLeaves";
import DryLeavesDescription from "./pages/DryLeavesDescription";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/extracts" element={<Extracts/>}/>
                <Route path="/oils" element={<EssentialOils/>}/>

        <Route path="/product/:id" element={<ProductDetails />} />
                <Route path="/oil/:id" element={<OilDetails />} />

                                <Route path="/dry-leaves" element={<DryLeaves />} />
                                                                <Route path="/dry-leaves/:id" element={<DryLeavesDescription />} />



      </Routes>
    </BrowserRouter>
  );
}

export default App;